import { render, staticRenderFns } from "./ActivityTypesPage.vue?vue&type=template&id=33a4507a"
import script from "./ActivityTypesPage.vue?vue&type=script&lang=js"
export * from "./ActivityTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports